export const Legal = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3_567)">
      <path
        d="M11.4706 2.21916L5.47058 8.21918C5.17768 8.51207 5.17768 8.98695 5.47058 9.27984L6.97075 10.78C7.26364 11.0729 7.73851 11.0729 8.03141 10.78L14.0314 4.77999C14.3243 4.4871 14.3243 4.01222 14.0314 3.71933L12.5313 2.21916C12.2384 1.92627 11.7635 1.92627 11.4706 2.21916Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7207 10.4692L13.7207 16.4692C13.4278 16.7621 13.4278 17.2369 13.7207 17.5298L15.2209 19.03C15.5138 19.3229 15.9886 19.3229 16.2815 19.03L22.2816 13.03C22.5744 12.7371 22.5744 12.2622 22.2816 11.9693L20.7814 10.4692C20.4885 10.1763 20.0136 10.1763 19.7207 10.4692Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6556 5.15564L19.3444 10.8444"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.40564 10.4056L14.0944 16.0944"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.375 14.375L5.71876 21.0312C5.42003 21.3289 5.01549 21.4961 4.59376 21.4961C4.17202 21.4961 3.76748 21.3289 3.46876 21.0312C3.17106 20.7325 3.00391 20.328 3.00391 19.9062C3.00391 19.4845 3.17106 19.08 3.46876 18.7812L10.125 12.125"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_567">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
